<template>
  <div />
</template>

<script>
export default {
  name: 'TicketNewRoute',
  created() {
    // Keep "new ticket" as a dialog inside the list page (better UX than a full-screen form).
    // Deep link to /tickets/new -> redirect to /tickets?create=1 to open the dialog.
    this.$router.replace({ path: '/tickets', query: { ...this.$route.query, create: '1' } });
  }
};
</script>

